import moment from "moment";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  useGridApiContext,
  gridSortedRowIdsSelector,
  gridClasses,
} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { Button } from "@mui/material";
// import { ReactComponent as ExcelIcon } from "@deere/ux.brand-foundations/icons/excel.svg";
import Stack from "@mui/material/Stack";

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[100],
  },
}));

const getUnfilteredRows = ({ apiRef }) => gridSortedRowIdsSelector(apiRef);

const buttonBaseProps = {
  //   color: "primary",
  size: "small",
  startIcon: <fuel-icon name={"microsoft_excel"} />,
};

const CustomToolbar = () => {
  const apiRef = useGridApiContext();

  const handleExport = (options) => apiRef.current.exportDataAsCsv(options);
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <Button
        {...buttonBaseProps}
        onClick={() => handleExport({ getRowsToExport: getUnfilteredRows })}
      >
        Download
      </Button>
    </GridToolbarContainer>
  );
};
const LabelSupplierTable = (props) => {
  const { supplierTest, supplierNumber, noTpData } = props;
  const { oktaAuth } = useOktaAuth();

  const handleClickOpen = async (event) => {
    const imageURL = event.row.input_url;
    if (imageURL === null) {
      window.alert("Oops, File is empty.");
      console.log(imageURL);
    } else {
      const typeCheck = imageURL.slice(
        (Math.max(0, imageURL.lastIndexOf(".")) || Infinity) + 1
      );
      let index = imageURL.lastIndexOf("/") + 1;
      let tempFileName = supplierNumber + "/" + imageURL.slice(index);
      let type = "";
      if (typeCheck === "pdf") {
        type = "application/pdf";
      } else if (typeCheck === "bmp") {
        type = "image/bmp";
      } else if (typeCheck === "png") {
        type = "image/png";
      } else {
        type = "image/jpg";
      }
      downloadReport(tempFileName, type);
    }
  };

  const downloadReport = (data, types) => {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/downloadLabelfilefroms3/", {
        params: {
          fileName: data,
        },
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + oktaAuth.getAccessToken(),
        },
      })
      .then((response) => {
        const file = new Blob([response.data], { type: types });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const columns = [
    { field: "history_id", headerName: "Test Case ID", width: 120 },
    { field: "user_id", headerName: "Supplier", width: 120 },
    {
      field: "date_tested",
      headerName: "Date Tested",
      width: 170,
      valueFormatter: (params) => moment(params?.value).format("DD-MM-YYYY"),
    },
    {
      field: "filename",
      headerName: "File Name",
      width: 170,
      renderCell: (params) => (
        <a onClick={(data) => handleClickOpen(params)}>
          <Button variant="text" sx={{ cursor: "pointer" }}>
            {params.value}
          </Button>
        </a>
      ),
    },
    {
      field: "tested_file_type",
      headerName: "Test Image",
      align: "center",
      width: 110,
      valueFormatter: (params) => (params.value === null ? "--" : params.value),
    },
    {
      field: "label_type",
      headerName: "Label Type",
      width: 140,
      valueFormatter: (params) => (params.value === null ? "--" : params.value),
    },
    {
      field: "supplier_name",
      headerName: "User",
      width: 140,
      valueFormatter: (params) => (params.value === null ? "--" : params.value),
    },
    {
      field: "test_status",
      headerName: "Test(Individual Page)Compliance",
      width: 170,
      valueFormatter: (params) => (params.value === "Y" ? "Yes" : "No"),
    },
    {
      field: "one_d_errors",
      headerName: "1D Errors",
      width: 350,
      renderCell: (params) => (
        <Tooltip placement="bottom-start" title={params.value}>
          <span className="csutable-cell-trucate">
            {params.value === "" ? "--" : params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "two_d_errors",
      headerName: "2D Errors",
      width: 350,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span className="csutable-cell-trucate">
            {params.value === "" ? "--" : params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "total_file_compliance",
      headerName: "Test (Total File) Compliance",
      align: "center",
      width: 120,
      valueFormatter: (params) => (params.value === null ? "--" : params.value),
    },
    {
      field: "page_number",
      headerName: "Page Number",
      width: 120,
      valueFormatter: (params) => (params.value === null ? "--" : params.value),
    },
  ];

  const rows = supplierTest.map((e) => {
    const data = {
      history_id: e.history_id,
      user_id: e.user_id,
      date_tested: e.date_tested,
      filename: e.filename,
      tested_file_type: e.tested_file_type,
      label_type: e.label_type,
      supplier_name: e.supplier_name,
      test_status: e.test_status,
      one_d_errors: e.one_d_errors,
      two_d_errors: e.two_d_errors,
      total_file_compliance: e.total_file_compliance,
      page_number: e.page_number,
      input_url: e.input_url,
    };
    return data;
  });

  return (
    <>
      <Box sx={{ height: 380, width: "100%" }}>
        <StripedDataGrid
          rows={rows}
          columns={columns}
          // density="compact"
          autoHeight={false}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          getCellClassName={(params) => {
            return "cell";
          }}
          getRowId={(row) => row.history_id}
          components={{
            Toolbar: CustomToolbar,
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                <div style={{ fontWeight: "bold" }}>{noTpData}</div>
              </Stack>
            ),
          }}
        />
      </Box>
    </>
  );
};

export default LabelSupplierTable;
